<template>
  <b-modal
    v-model="showModal"
    title="Tạo phiếu khiếu nại"
    size="lg"
    ok-title="Tạo"
    cancel-title="Hủy"
    @ok="handleOk"
    @hidden="resetForm"
    :ok-disabled="submitting"
    hide-backdrop
  >
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col md="6">
          <b-form-group label="ID đơn hàng sàn" label-for="platformOrderId">
            <b-form-input
              id="platformOrderId"
              v-model.number="form.platformOrderId"
              type="number"
              placeholder="ID đơn hàng"
              required
              :disabled="!!initialPlatformOrderId"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Ngày khiếu nại" label-for="complaintDate">
            <b-input-group>
              <date-picker
                id="complaintDate"
                v-model="form.complaintDate"
                class="form-control"
                :config="dpConfigs.date"
                placeholder="Chọn ngày"
                required
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="ID đơn hàng (nội bộ)" label-for="orderId">
            <b-form-input
              id="orderId"
              v-model.number="form.orderId"
              type="number"
              placeholder="ID đơn hàng nội bộ"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Đơn vị vận chuyển" label-for="shippingUnit">
            <b-form-input
              id="shippingUnit"
              v-model="form.shippingUnit"
              placeholder="VD: GHN, Viettel Post"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <b-form-group label="Số tiền bồi hoàn" label-for="compensationAmount">
            <BInputNumber
              id="compensationAmount"
              v-model="form.compensationAmount"
              size="sm"
              placeholder="VD: 500000"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Số tiền tổn thất" label-for="lossAmount">
            <BInputNumber
              id="lossAmount"
              v-model="form.lossAmount"
              size="sm"
              placeholder="VD: 100000"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Lý do khiếu nại" label-for="complaintReasonId">
            <b-form-select
              id="complaintReasonId"
              class="select-style"
              v-model="form.complaintReasonId"
              :options="reasonOptions"
              value-field="id"
              text-field="name"
              placeholder="Chọn lý do"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Chọn lý do khiếu nại</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Trạng thái xử lý" label-for="processingStatusId">
            <b-form-select
              id="processingStatusId"
              class="select-style"
              v-model="form.processingStatusId"
              :options="statusOptions"
              value-field="id"
              text-field="name"
              placeholder="Chọn trạng thái"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >Chọn trạng thái xử lý</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Ghi chú" label-for="notes">
            <b-form-textarea
              id="notes"
              v-model="form.notes"
              rows="3"
              placeholder="Nhập ghi chú"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <template #modal-footer>
      <b-button variant="secondary" @click="showModal = false">Hủy</b-button>
      <b-button variant="primary" @click="handleSubmit" :disabled="submitting">
        <b-spinner v-if="submitting" small></b-spinner>
        <span v-else>Tạo phiếu</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { getToastInstance } from '@/utils/toastHelper';
import timeUtils from '@/utils/date';
import moment from 'moment';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';

const shopeeAdminRepo = RepositoryFactory.get('shopeeAdmin');
const toast = getToastInstance();

export default {
  name: 'CreateComplaintModal',
  components: { BInputNumber },
  data() {
    return {
      showModal: false,
      submitting: false,
      initialPlatformOrderId: null,
      reasons: [],
      statuses: [],
      form: {
        platformOrderId: null,
        complaintDate: null,
        orderId: null,
        shippingUnit: '',
        complaintReasonId: null,
        processingStatusId: null,
        notes: '',
        compensationAmount: null,
        lossAmount: null,
      },
    };
  },
  computed: {
    dpConfigs() {
      return timeUtils.DP_CONFIG;
    },
    reasonOptions() {
      return this.reasons || [];
    },
    statusOptions() {
      return this.statuses || [];
    },
  },
  methods: {
    async open(order = null) {
      this.initialPlatformOrderId = null;
      if (order) {
        this.form.platformOrderId = order.platformOrderId ?? order.id;
        this.form.orderId = order.orderId ?? null;
        this.initialPlatformOrderId = this.form.platformOrderId;
      }
      this.form.complaintDate = moment().format('DD/MM/YYYY');
      this.form.shippingUnit = '';
      this.form.complaintReasonId = null;
      this.form.processingStatusId = null;
      this.form.notes = '';
      this.form.compensationAmount = null;
      this.form.lossAmount = null;

      await this.fetchReasons();
      await this.fetchStatuses();
      this.showModal = true;
    },
    async fetchReasons() {
      try {
        this.reasons = await shopeeAdminRepo.getComplaintReasons();
      } catch (e) {
        toast.makeToastFailure('Không tải được danh sách lý do khiếu nại');
        this.reasons = [];
      }
    },
    async fetchStatuses() {
      try {
        this.statuses = await shopeeAdminRepo.getComplaintStatuses();
      } catch (e) {
        toast.makeToastFailure('Không tải được danh sách trạng thái xử lý');
        this.statuses = [];
      }
    },
    resetForm() {
      this.form = {
        platformOrderId: null,
        complaintDate: null,
        orderId: null,
        shippingUnit: '',
        complaintReasonId: null,
        processingStatusId: null,
        notes: '',
        compensationAmount: null,
        lossAmount: null,
      };
    },
    handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      if (!this.form.platformOrderId) {
        toast.makeToastFailure('Vui lòng nhập ID đơn hàng sàn');
        return;
      }
      if (!this.form.complaintDate) {
        toast.makeToastFailure('Vui lòng chọn ngày khiếu nại');
        return;
      }

      const complaintDate = moment(this.form.complaintDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD',
      );

      const payload = {
        platformOrderId: Number(this.form.platformOrderId),
        complaintDate,
        orderId: this.form.orderId ? Number(this.form.orderId) : undefined,
        shippingUnit: this.form.shippingUnit || undefined,
        complaintReasonId: this.form.complaintReasonId
          ? Number(this.form.complaintReasonId)
          : undefined,
        processingStatusId: this.form.processingStatusId
          ? Number(this.form.processingStatusId)
          : undefined,
        notes: this.form.notes || undefined,
        compensationAmount:
          this.form.compensationAmount != null &&
          this.form.compensationAmount !== ''
            ? Number(this.form.compensationAmount)
            : undefined,
        lossAmount:
          this.form.lossAmount != null && this.form.lossAmount !== ''
            ? Number(this.form.lossAmount)
            : undefined,
      };

      try {
        this.submitting = true;
        await shopeeAdminRepo.createComplaint(payload);
        toast.makeToastSuccess('Tạo phiếu khiếu nại thành công');
        this.showModal = false;
        this.$emit('created');
      } catch (error) {
        const msg =
          error?.response?.data?.message || 'Không thể tạo phiếu khiếu nại';
        toast.makeToastFailure(msg);
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>
